<template>
    <div class="footer">
        Dealer Audi
        <br>
        <strong>Porsche Poznań Franowo</strong>
        <br>
        ul. Adama Kręglewskiego 2, 61-248 Poznań
        <!-- <br> -->
        <!-- tel.: <a href="tel:616501666">+48 61 650 16 66</a> -->
        <br>
        <a href="http://www.audipoznan.pl/">www.audipoznan.pl</a>
    </div>
</template>

<script>
export default {
  name: 'bottomFooter'
}
</script>

<style lang="scss" scoped>
    .footer{
        margin-right: 1rem;
        color: #4c4c4c;
        padding: 2rem 0;
        // border-top: 2px solid #4c4c4c;
        a{
            color: #4c4c4c;
            text-decoration:none;
        }
    @media(max-width: 960px){
        padding: 2rem;
        margin-right: 0;
     }
    }
</style>
